import { render, staticRenderFns } from "./ShowAnnouncement.vue?vue&type=template&id=d1b8863c&scoped=true"
import script from "./ShowAnnouncement.vue?vue&type=script&lang=js"
export * from "./ShowAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./ShowAnnouncement.vue?vue&type=style&index=0&id=d1b8863c&prod&lang=less"
import style1 from "./ShowAnnouncement.vue?vue&type=style&index=1&id=d1b8863c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b8863c",
  null
  
)

export default component.exports